import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import classifications from "../../../assets/business-time.json";
import { BusinessClassificationActions } from "../actions/business-classification.actions";
import { FailState } from "../models/fail-state";
import { AppState } from "../reducers";
import { BusinessClassificationSelectors } from "../selectors/business-classification.selectors";

@Injectable()
export class BusinessClassificationEffects {
	private classifications = classifications;

	requested = createEffect(() =>
		this.actions.pipe(
			ofType(BusinessClassificationActions.requested),
			withLatestFrom(
				this.store.pipe(select(BusinessClassificationSelectors.businessClassifications))
			),
			switchMap(([action, bclasses]) =>
				_.has(bclasses, "classification") && !bclasses.loading
					? of(BusinessClassificationActions.loaded(bclasses))
					: of(BusinessClassificationActions.apiRequested())
			)
		)
	);

	apiRequested = createEffect(() =>
		this.actions.pipe(
			ofType(BusinessClassificationActions.requested),
			switchMap(() =>
				of(this.classifications).pipe(
					map((bclasses) =>
						BusinessClassificationActions.loaded({
							classifications: bclasses,
							loading: false
						})
					),
					catchError((error) =>
						of(BusinessClassificationActions.failed(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>
	) {}
}
